import React, { FC, useRef, useState } from 'react';
import { formatValueToNumber, formatValueToString } from '../../../helpers';
import { InfoAlert } from '../../../types';

import './formatted-number-input.css';

interface Props {
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  value: number;
  setInfoAlert: (infoType: InfoAlert | null) => void;
}

export const FormattedNumberInput: FC<Props> = ({
  onChange,
  min = 1,
  max,
  step = 1,
  value = 1,
  setInfoAlert,
}) => {

  const [currValueStr, setCurrValueStr] = useState(formatValueToString(value));
  const inputRef = useRef<HTMLInputElement | null>(null);

  const checkValueValidation = (valueByStep?: number) => {
    const currValue = valueByStep ? valueByStep : formatValueToNumber(currValueStr);

    setInfoAlert(null);
    max && currValue > max && setInfoAlert(InfoAlert.MAX);
    min && currValue < min && setInfoAlert(InfoAlert.MIN);

    const val = (max && currValue > max) ? max : (min && currValue < min) ? min : (currValue % step) > 0 ? value : currValue;

    setWidth(`${val}`.length);

    onChange(val);
    setCurrValueStr(formatValueToString(val));
  };

  const insertValue = () => {
    setWidth(inputRef!.current!.value.length);

    setCurrValueStr(inputRef!.current!.value);
  };

  const setWidth = (charLength: number) => {
    if (inputRef && inputRef.current) {
      const width = (charLength + 2);
      inputRef.current.style.width = Math.max(2, Math.min(width, 10)) + 'ch';
    }
  };

  const countDown = () => {
    checkValueValidation(value - step);
  };

  const countUp = () => {
    checkValueValidation(value + step);
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (['Enter', 'NumpadEnter'].includes(event.code)) {
      checkValueValidation();
    }

    if (['ArrowDown'].includes(event.code)) {
      countDown();
    }
    if (['ArrowUp'].includes(event.code)) {
      countUp();
    }
  };

  return (
    <label className="formatted-number-wrapper">
      <input
        ref={inputRef}
        type="text"
        pattern="[0-9 ]+"
        className="formatted-number-input"
        onChange={insertValue}
        min={min}
        max={max}
        step={step}
        value={currValueStr}
        onBlur={() => checkValueValidation()}
        onKeyDown={onKeyDown}
      />
      <div className="arrow-wrapper">
        <span onClick={countUp}>
          <i className="arrow up" />
        </span>
        <span onClick={countDown}>
          <i className="arrow down" />
        </span>
      </div>
    </label>
  );
};
